import ZocksLogo from '../../../assets/images/zocks-logo-black.svg'
import { Link } from 'react-router-dom'
import * as React from 'react'

export interface LoginHeaderParams {
  hideAccountCreation?: boolean
}

export const SignupHeader = ({ hideAccountCreation = false }: LoginHeaderParams) => (
  <div className='auth-header'>
    <img className='auth-logo' src={ZocksLogo} alt='Zocks logo' />
    {!hideAccountCreation ? (
      <div className='auth-header-text'>
        <div>New user?</div>
        <div className='auth-header-link'>
          <Link to={'/signup'}>Create an account</Link>
        </div>
      </div>
    ) : null}
  </div>
)
